import convertDate from 'shared/utils/convertDate';
import Address from './Address';

class Employer {
	constructor(employer = {}) {
		this.address = employer.address1 != null ? new Address(employer) : new Address();
		this.employmentTermEndDate = convertDate(employer.employmentTermEndDate) || '';
		this.employmentTermStartDate = convertDate(employer.employmentTermStartDate) || '';
		this.jobTitle = employer.jobTitle || '';
		this.name = employer.name || '';
		this.phone = employer.phone || '';
	}
}

export default Employer;
